<app-page>
    @if (loading$ | async) {
        <app-loading-bar></app-loading-bar>
    } @else if (error$ | async) {
        <app-system-response
            responseType="error"
            size="small"
        ></app-system-response>
    } @else {
        @if (updateData$ | async; as data) {
            <div class="card-section">
                <div class="card-wrapper">
                    <app-update-card class="card"
                        ><div header>
                            <translate>Latest changes to traigo</translate>
                        </div>
                        <div body>
                            <div class="card__content-body-title">
                                {{ data?.firstUpdate?.headline }}
                            </div>
                            <p [innerHTML]="data.firstUpdate.overview"></p></div
                    ></app-update-card>
                </div>
            </div>
            <mat-divider class="divider"></mat-divider>
            <div class="card-section" *ngFor="let update of data.otherUpdates">
                <div class="card-wrapper">
                    <app-update-card class="card" flat>
                        <div header>
                            {{
                                (update.createdAt | date: 'dd.MM.yyyy') +
                                    ' ' +
                                    update.headline
                            }}
                        </div>
                        <div body>
                            <p [innerHTML]="update.overview"></p>
                        </div>
                    </app-update-card>
                </div>
            </div>
        } @else {
            <app-system-response
                responseType="empty"
                size="small"
            ></app-system-response>
        }
    }
</app-page>
